// @flow

import { noop } from "lodash";
import type { UnaryFn, QuinFn } from "@tvg/types/Functional";

const TVG1Stream = "tvg_mbr";
const TVG2Stream = "tvg2_mbr";

const initVideoStream = (
  streamName: string,
  replayFile: string,
  channel: boolean,
  videoOnModal: boolean,
  isStreamHighDefinition: boolean,
  getStreamSrc: QuinFn<
    string,
    string,
    boolean,
    boolean,
    ?UnaryFn<?{ message: string, code: Number }, void>,
    Promise<mixed>
  > = () => new Promise(noop),
  onError: ?UnaryFn<?{ message: string, code: Number }, void>
) => {
  if (channel) {
    return getStreamSrc(
      streamName === "TVG" ? TVG1Stream : TVG2Stream,
      replayFile,
      videoOnModal,
      true,
      onError
    );
  }
  return getStreamSrc(
    streamName,
    replayFile,
    videoOnModal,
    isStreamHighDefinition,
    onError
  );
};

export default initVideoStream;
